export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })
  const ETHSendArgs = IDL.Record({
    max_fee_per_gas: IDL.Nat,
    nonce: IDL.Nat64,
    gas_limit: IDL.Nat64,
    amount: IDL.Nat,
    receiver: IDL.Text,
  })
  return IDL.Service({
    eth_address: IDL.Func([IDL.Principal], [Result], []),
    usdc_icp: IDL.Func([ETHSendArgs], [Result], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
